import styled from 'styled-components'

import { getColor } from 'hsds/utils/color'

export const IconUI = styled.span`
  color: currentColor;
  display: block;
  height: 20px;
  width: 20px;
  position: relative;

  &.is-center {
    margin-left: auto;
    margin-right: auto;
  }

  &.is-clickable {
    cursor: pointer;
  }

  &.is-inline {
    display: inline-block;
  }

  &.is-noInteract {
    pointer-events: none;
  }

  &.is-offsetLeft {
    margin-right: 4px;
  }

  &.is-offsetRight {
    margin-left: 4px;
  }

  &.is-default {
    color: ${getColor('text.default')};
  }

  &.is-subtle {
    color: ${getColor('text.subtle')};
  }

  &.is-slightlyMuted {
    color: ${getColor('text.slightlyMuted')};
  }

  &.is-muted {
    color: ${getColor('text.muted')};
  }

  &.is-faint {
    color: ${getColor('text.faint')};
  }

  &.is-extraMuted {
    color: ${getColor('text.extraMuted')};
  }

  &.is-8 {
    height: 8px;
    width: 8px;
  }

  &.is-10 {
    height: 10px;
    width: 10px;
  }

  &.is-12 {
    height: 12px;
    width: 12px;
  }

  &.is-13 {
    height: 13px;
    width: 13px;
  }

  &.is-14 {
    height: 14px;
    width: 14px;
  }

  &.is-15 {
    height: 15px;
    width: 15px;
  }

  &.is-16 {
    height: 16px;
    width: 16px;
  }

  &.is-18 {
    height: 18px;
    width: 18px;
  }

  &.is-20 {
    height: 20px;
    width: 20px;
  }

  &.is-24 {
    height: 24px;
    width: 24px;
  }

  &.is-32 {
    height: 32px;
    width: 32px;
  }

  &.is-48 {
    height: 48px;
    width: 48px;
  }

  &.is-52 {
    height: 52px;
    width: 52px;
  }

  &.is-72 {
    height: 72px;
    width: 72px;
  }

  &.is-error {
    color: ${getColor('state.error.icon')};
  }

  &.is-success {
    color: ${getColor('state.success.icon')};
  }

  &.is-warning {
    color: ${getColor('state.warning.icon')};
  }

  .c-Icon__icon {
    color: currentColor;
    display: block;
    height: 100%;
    pointer-events: none;

    svg {
      display: block;
      height: 100%;
      max-width: 100%;
      width: 100%;
    }

    circle[fill],
    path,
    rect[fill] {
      fill: currentColor;
    }
    path[stroke] {
      fill: none;
    }

    ellipse[stroke],
    circle[stroke],
    path[stroke],
    rect[stroke] {
      stroke: currentColor;
    }
  }
`
